import { render, staticRenderFns } from "./customizertool.vue?vue&type=template&id=1add217a&"
import script from "./customizertool.vue?vue&type=script&lang=js&"
export * from "./customizertool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports